import { render, staticRenderFns } from "./StandardTemplateReports.vue?vue&type=template&id=b42b49e6&scoped=true&"
import script from "./StandardTemplateReports.vue?vue&type=script&lang=js&"
export * from "./StandardTemplateReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42b49e6",
  null
  
)

export default component.exports